export default "__VITE_ASSET__Tr2jfyMH__"